// @core/api/endpoints/project/create_saved_view.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateSavedViewRequest,
  SavedViewResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Create saved view
 * Creates a saved filter/sort/group configuration for boards or list views. Views can be private or shared with the team.
 */
export async function CreateSavedView(
  project_id: string,
  data: CreateSavedViewRequest,
  options?: RequestOptions
): Promise<SavedViewResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/views`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  const requestOptions = options;
  return client.post<SavedViewResponse>(requestPath, data, requestOptions);
}
